module.exports = __webpack_public_path__ + "images/category_lp/watch/watch_b51b941895662c1c5becffff0f65a1aa.png";